import React from 'react';
import classNames from "classnames";
import {FaBook} from "react-icons/fa";
import {CgProfile} from "react-icons/cg";
import {LiaChalkboardTeacherSolid} from "react-icons/lia";

export function ChatBubble({message}) {

    const bubbleClass = classNames("rounded-1 px-2 pt-2 mb-2", {
        "bg-light border": message.type === "USER",

    })


    if(message.contentType === "SAMTALE") {
        return (
            <div className={"chat-bubble-message my-3"} style={{marginLeft:"10vw"}}>
                <div className={"explain-text"}>
                    <p className={" "}><i>"{message.content}"</i></p>
                </div>
            </div>
        );
    }


    if(message.contentType === "FORKLAR") {
        return (
            <div className={"chat-bubble my-3"} style={{marginLeft:"10vw"}}>
                <div className={"explain-text"}>
                    <p className={" "}><i>"{message.content}"</i></p>
                </div>
            </div>
        );
    }

    if(message.contentType === "UTDYP") {
        return (
            <div className={"p-3 rounded-5 border border-danger"} style={{marginLeft:"10vw"}}>
                <div className={"d-flex align-items-center p-2  rounded mt-2"}>
                    <FaBook size={24} className={"me-2"}/>
                    <h5 className={"m-0 p-0 fw-bold"}>Utdyp</h5>
                </div>
                <div className={""}>
                    <p className={" "}><i>"{message.content}"</i></p>
                </div>
            </div>
        );
    }

}